itsoftApp.createModule("scrollTo", ["windowResize", "startLoad"], function () {
    const module = this;
    const sideNav = document.querySelector(".sticky-layout__left");

    const ResponsiveScroll = function () {
        this.duration = 2;
        this.init();
    };

    const getSidenavHeight = function () {
        const sideNavHeight = sideNav ? sideNav.offsetHeight : 0;
        return sideNavHeight;
    }

    ResponsiveScroll.prototype.scrollTo = function (hash) {
        const RESPONSIVE_SCROLL = this;
        let mm = gsap.matchMedia();

        mm.add("(min-width: 1024px)", () => {
            gsap.to(window, {
                duration: RESPONSIVE_SCROLL.duration,
                scrollTo: {
                    y: hash,
                    offsetY: itsoftApp.calculations.headerFixedHeight
                }
            })
        });

        mm.add("(max-width: 1023px)", () => {
            gsap.to(window, {
                duration: RESPONSIVE_SCROLL.duration,
                scrollTo: {
                    y: hash,
                    offsetY: itsoftApp.calculations.headerFixedHeight + getSidenavHeight()
                }
            })
        });
    }

    ResponsiveScroll.prototype.onLinkClick = function (evt) {
        evt.preventDefault();
        const RESPONSIVE_SCROLL = this;
        const target = evt.currentTarget;
        const hash = target.getAttribute("href");
        if (!itsoftApp.libraries.scrollToPlugin.loaded) {
            new itsoftApp.modules.startLoad.callback(function () {
                RESPONSIVE_SCROLL.scrollTo(hash);
            }, itsoftApp.libraries.scrollToPlugin);
        } else {
            RESPONSIVE_SCROLL.scrollTo(hash);
        }
    }

    ResponsiveScroll.prototype.init = function () {
        const RESPONSIVE_SCROLL = this;

        if (itsoftApp.state.hashActive) {
            new itsoftApp.modules.startLoad.callback(function () {
                RESPONSIVE_SCROLL.scrollTo(itsoftApp.state.hash);
            }, itsoftApp.libraries.scrollToPlugin);
        }

        const links = document.querySelectorAll("a[href^='#']:not([href='#'])");

        /* Проходимся по всем элементам, у которых в href есть хэш */
        Array.prototype.forEach.call(links, function (link) {
            link.addEventListener("click", RESPONSIVE_SCROLL.onLinkClick.bind(RESPONSIVE_SCROLL));
        });
    }

    itsoftApp.modules.pageLoad.addEvent(function () {
        new ResponsiveScroll();
    });

    module.callback = ResponsiveScroll;
});